/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import SimpleBettingHistory from '@components/SimpleBettingHistory'
import { formatCreatedAtToElapsedTime, makeAttachmentDetailObjToBettingRecordTrack } from '@utils/utils'
import { Schema$ChatMessage } from '@interface/chat'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import styled from '@themes/theme'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'
import useRootStore from '@store/useRootStore'
import * as _ from 'lodash'
import AdvImg from '@components/AdvImg'
import DialogUtils from '@utils/dialog-utils'

interface UserShareBettingHistoryItemProps {
  chatMessage: Schema$ChatMessage
}

const ShareBettingHistoryWrap = styled.div`
    background: ${props => props.theme.color.modalBg};

    .share-betting-history-list {
        width: calc(100% - 33px);
        margin: 0 auto;
        padding: 16px 0;
        border-bottom: 1px solid ${props => props.theme.color.modalSubBg2};
        display: flex;
        flex-wrap: nowrap;

        .user-profile {
            width: 40px;
            height: 40px;
            position: relative;

            .profile-img-wrap {
                ${ProfileImgWrapStyle};
            }

            .mark {
                position: absolute;
                top: 25px;
                left: 25px;
            }
        }

        .contents {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-left: 12px;

            .contents-info {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;

                .nick-info {
                    font-size: ${props => props.theme.font.medium};
                    font-weight: ${props => props.theme.fontW.bold};
                    color: ${props => props.theme.color.modalTxt};
                }

                .date {
                    margin: 0 10px 0 auto;
                    font-size: ${props => props.theme.font.medium};
                    font-weight: ${props => props.theme.fontW.medium};
                    color: ${props => props.theme.color.modalgray};
                }
            }

            .chat-bubble {
                display: flex;
                flex-wrap: wrap;
                flex-flow: column;
                align-items: flex-start;
                background: ${props => props.theme.color.modalSubBg2};
                width: auto;
                max-width: calc(100% - 36px);
                height: auto;
                padding: 7px 10px;
                border-radius: 0 10px 10px 10px;

                &-txt {
                    word-break: break-word;
                    white-space: pre-wrap;
                    line-height: 1.8rem;
                    text-align: left;
                    width: 100%;
                    font-size: ${props => props.theme.font.medium};
                    font-weight: ${props => props.theme.fontW.medium};
                    color: ${props => props.theme.color.modalTxt};
                }
            }
        }

        &:first-of-type {
            padding-top: 22px;
        }
    }
`

export const UserShareBettingHistoryItem: React.FC<UserShareBettingHistoryItemProps> = observer((props) => {
  const { chatMessage } = props
  const { authStore } = useRootStore()
  const { attachmentDetail } = chatMessage
  const { userInfo } = authStore

  const attachmentDetailObj = attachmentDetail ? JSON.parse(attachmentDetail) as any : undefined

  const onClickOpenBettingListInfo = () => {
    DialogUtils.showSharedBettingList({ betId: attachmentDetailObj.bettorBetId, fromUserNick: userInfo.nick })
  }

  let content: string
  if (chatMessage.filteredContents) {
    content = chatMessage.filteredContents
  } else {
    content = chatMessage.contents
  }

  return (
    <ShareBettingHistoryWrap>
      <div key={chatMessage.id} className="share-betting-history-list">
        <div className="user-profile">
          <div className="profile-img-wrap lhn33">
            <AdvImg src={chatMessage.fromUserProfileImg} srcMode={'small'} alt="스킨 프로필" className="profile-img"/>
          </div>
          <UserPickSpecialMemberMark
            showSMark={userInfo.isSpecialMember} small lightBorder
            isSpecialMember={!_.isNil(userInfo.sMemberMark)}
            userTitleId={userInfo.userTitleId}
            userTitleEnabled={userInfo.userTitleEnabled}
          />
        </div>

        <div className="contents">
          <div className="contents-info">
            <p className="nick-info">{chatMessage.fromUserNick}</p>
            <p className="date">{formatCreatedAtToElapsedTime({ createdAt: chatMessage.createdAt })}</p>
          </div>
          <div className="chat-bubble">
            <SimpleBettingHistory
              // isFold // TODO: fold 베팅내역일 경우
              bettingRecordTrack={makeAttachmentDetailObjToBettingRecordTrack(attachmentDetailObj)}
              onClickOpenBettingListInfo={onClickOpenBettingListInfo}
            />
            <p className="chat-bubble-txt">{content}</p>
          </div>
        </div>
      </div>
    </ShareBettingHistoryWrap>
  )
})
